<template>
  <multiselect-base v-bind="$attrs" v-on="$listeners">
    <template
      v-for="(_, slotName) in $scopedSlots"
      #[slotName]="slotData"
    >
      <slot :name="slotName" v-bind="slotData || {}" />
    </template>
    <template v-if="!$scopedSlots.noOptions" #noOptions>
      <div class="multiselect__option">
        {{ $t('FORMS.MULTISELECT.NO_OPTIONS') }}
      </div>
    </template>
    <template v-if="!$scopedSlots.noResult" #noResult>
      <div class="multiselect__option">
        {{ $t('FORMS.MULTISELECT.NO_RESULT') }}
      </div>
    </template>
  </multiselect-base>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'WootMultiselect',
  components: { MultiselectBase: Multiselect },
  inheritAttrs: false,
};
</script>
